document.addEventListener('DOMContentLoaded', () => { 
    const nextButton = document.querySelector('.js-internal-nav-next');
    const prevButton = document.querySelector('.js-internal-nav-prev');
    const innerNav = document.querySelector('.js-internal-nav ul');
    const buttonWrapper = document.querySelector('.js-internal-nav-buttons');

    const disableButtons = (navItems) => {
        if (!navItems || navItems.length === 0) {
          return;
        }
    
        if (navItems[0].classList.contains('first-visible')) {
          prevButton.setAttribute('disabled', 'true');
        } else {
          prevButton.removeAttribute('disabled');
        }
        if (navItems[navItems.length - 1].classList.contains('last-visible')) {
          nextButton.setAttribute('disabled', 'true');
        } else {
          nextButton.removeAttribute('disabled');
        }
      };

      nextButton.addEventListener('click', () => {
        const currentActive = document.querySelector('.last-visible');
        const nextItem = currentActive.nextElementSibling;
        if (!currentActive || !nextItem) return;
        innerNav.scrollLeft += nextItem.offsetWidth + 56;
        updateVisibleEls(tocListItems);
      });
    
      prevButton.addEventListener('click', () => {
        const currentActive = document.querySelector('.first-visible');
        const prevItem = currentActive.previousElementSibling;
        if (!currentActive || !prevItem) return;
        innerNav.scrollLeft -= prevItem.offsetWidth;
        updateVisibleEls(tocListItems);
      });
});